// src/services/collabService.js
import api from './apiClient';

export const setPermission = ({ recipe_id, user_id, email, username, can_edit = false, can_comment = true }) =>
  api.post('/api/collab/permissions', {
    recipe_id,
    user_id,
    email,        // ✅ required for syncing
    username,     // ✅ optional but useful
    can_edit,
    can_comment,
  });

export const getPermissions = (recipeId) =>
  api.get(`/api/collab/permissions?recipe_id=${recipeId}`);

export const lockRecipe = (recipeId) =>
  api.post(`/api/collab/lock/${recipeId}`);

export const unlockRecipe = (recipeId) =>
  api.post(`/api/collab/unlock/${recipeId}`);

export const fetchComments = (recipeId) =>
  api.get(`/api/collab/comments/${recipeId}`);

export const postComment = (data) =>
  api.post(`/api/collab/comments`, data);

export const getChangeLog = (recipeId) =>
  api.get(`/api/collab/change-log/${recipeId}`);